import config from '../../../config';

const TILE_SIZE = config.TILE_SIZE;

function initBumpers (layer) {
  let g = this.g;

  _.each(layer.groups.tiles, (sprite) => {
    let name = sprite.frame.name;
    let bump = name.split('-').slice(2);
    sprite.setTexture('bumper');
    bump[1] = bump[1].replace('.png', '');
    sprite.bump = bump;
    switch (_.join(bump, '-')) {
      case 'down-right':
        sprite.setAngle(180);
        break;
      case 'down-left':
        sprite.setAngle(270);
        break;
      case 'up-right':
        sprite.setAngle(90);
        break;
      case 'up-left':
        break;
    }
  });
}

export {
  initBumpers
};
